import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { AuthService } from './auth.service';
import { EnvService } from './env.service';

@Injectable()
export class AuthTokenInterceptor implements HttpInterceptor {

  constructor(private authService: AuthService) { }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const nextReq = (!req.url.startsWith(this.authService.getSSOUrl()))
      ? req.clone({ headers: req.headers.set('Authorization', `Bearer ${this.authService.getToken()}`) })
      : req;
    return next.handle(nextReq);
  }
}
